import React from 'react';

import { DropdownItem } from '@atlaskit/dropdown-menu';
import ClockIcon from '@atlaskit/icon/core/clock';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { fg } from '@confluence/feature-gating';
import { expVal } from '@confluence/feature-experiments';
import { useNewContentHistoryActions } from '@confluence/content-history-new/entry-points/useNewContentHistoryActions';

type ViewPageHistoryMenuItemProps = {
	label: string;
	isLivePage: boolean;
	contentType: string;
	itemId?: string;
	itemUrl?: string;
};

export const ViewPageHistoryMenuItem = ({
	label,
	isLivePage,
	contentType,
	itemId = '',
	itemUrl = '',
}: ViewPageHistoryMenuItemProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { showNewContentHistory } = useNewContentHistoryActions();

	return (
		<DropdownItem
			key={itemId}
			elemBefore={<ClockIcon label="" />}
			// When the experiment is enabled, we don't want to redirect live pages since it will be shown as an overlay in the editor
			href={
				isLivePage && expVal('confluence_content_history_updates', 'isEnabled', false)
					? undefined
					: itemUrl
			}
			onClick={() => {
				createAnalyticsEvent({
					type: 'sendUIEvent',
					data: {
						action: 'clicked',
						actionSubject: 'button',
						actionSubjectId: 'versionHistory',
						source: 'overflowMenu',
						attributes: {
							isContentWrapper: fg('confluence_frontend_content_wrapper'),
							isNewContentHistory: expVal('confluence_content_history_updates', 'isEnabled', false),
							isLivePage,
							contentType,
						},
					},
				}).fire();

				// Only live pages at the moment will have the "in editor" content history experience
				if (isLivePage && expVal('confluence_content_history_updates', 'isEnabled', false)) {
					showNewContentHistory();
				}
			}}
		>
			{label}
		</DropdownItem>
	);
};
